import styled from "styled-components";

export const SimWrapper = styled.div`
  /* Skeleton */
  .sim-image {
    transform: none;
    width: 370px;
    height: 220px;
  }
  display: grid;
  grid-template-columns: 370px 1fr;
  grid-gap: 45px;
  @media screen and (max-width: 992px) {
    grid-template-columns: 2fr 3fr;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: auto;
    /* Skeleton */
    .sim-image {
      width: 100%;
      height: 190px;
    }
  }
`;

export const RightContent = styled.div`
  height: fit-content;
  grid-row-gap: 1.5rem;
  color: var(--text-color-dark);
  figure {
    width: fit-content;
    img {
      border-radius: 12px;
    }
    .device-info {
      top: 12px;
      left: 12px;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 16px;
      padding: 0.5rem 1rem;
      display: flex;
      justify-content: space-between;
      grid-column-gap: 1rem;
      column-gap: 1rem;
      .icon:hover path {
        stroke: var(--secondary-color);
      }
    }
  }
  .book-button {
    padding: 10px;
    color: inherit;
    height: fit-content;
    background-color: var(--secondary-color);
    border-radius: 14px;
    display: flex;
    align-items: center;
    font-size: var(--font-size-md);
    justify-content: center;
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-sm);
    }
  }
`;

export const SimHashtagFilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 15px;
  a {
    grid-template-columns: none;
  }
`;

export const LeftContent = styled.div`
  .description p {
    line-height: 25px;
  }
  .bookmark-icon:hover {
    cursor: pointer;
  }
  footer {
    .sim-goals ul {
      list-style-type: none;
      li {
        display: grid;
        grid-template-columns: 25px 1fr;
        margin-bottom: 1rem;
        &::before {
          content: "";
          background-color: var(--secondary-color);
          border: 2px solid #fced9f;
          border-radius: 50%;
          margin-top: 5px;
          margin-left: 12px;
          width: 15px;
          height: 15px;
        }
      }
    }
    @media screen and (max-width: 576px) {
      .sim-goals ul li {
        margin-bottom: 0.5rem;
        font-size: var(--font-size-sm);
      }
    }
  }
  @media screen and (max-width: 576px) {
    h1 {
      font-size: var(--font-size-base);
    }
    b.free-label {
      font-size: var(--font-size-xs);
    }
    .description p {
      font-size: var(--font-size-sm);
    }
  }
`;

export const VideosSelectionWrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 15px;
  h6 {
    font-size: var(--font-size-lg);
  }
  @media screen and (max-width: 992px) {
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 30px;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: 100%;
    grid-row-gap: 30px;
    h6 {
      font-size: var(--font-size-base);
    }
  }
`;

export const StyledVideoTemplate = styled.div`
  transition: all ease 0.5s;
  transform: ${({ $isActive }) => $isActive && "translateY(-5px)"};
  &:hover {
    transform: ${({ $disabled }) => !$disabled && "translateY(-5px)"};
    div.blur-effect {
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      border-color: ${({ $disabled }) => !$disabled && "var(--secondary-color)"};
      .layer-icon {
        transition: all ease 0.5s;
        transition: ${({ $disabled }) => !$disabled && "all ease 0.5s"};
        path {
          fill: ${({ $disabled }) => !$disabled && "var(--secondary-color)"};
        }
      }
    }
  }
  div.blur-effect {
    max-width: 350px;
    height: 200px;
    min-height: 180px;
    border: #eaf8fb 8px solid;
    border-radius: 18px;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(73, 175, 194, 1) 31%,
      rgba(75, 176, 194, 1) 32%,
      rgba(172, 218, 227, 1) 69%,
      rgba(255, 255, 255, 1) 100%
    );
    cursor: ${({ $disabled }) => !$disabled && "pointer"};
    border-color: ${({ $isActive }) => $isActive && "var(--secondary-color)"};
    .layer-icon {
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      path {
        fill: ${({ $isActive }) => $isActive && "var(--secondary-color)"};
      }
    }
  }
`;

export const BottomWrapper = styled.footer`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: ". center left";
  margin-top: 4rem;
  a {
    grid-area: center;
    font-size: var(--font-size-lg);
    font-weight: 500;
  }
  p {
    grid-area: left;
    font-size: var(--font-size-sm);
    color: #1c3542;
  }
  @media screen and (max-width: 992px) {
    grid-template-columns: max-content 2fr 1fr;
    grid-template-areas: ". center left";
  }
  @media screen and (max-width: 576px) {
    grid-template-columns: 100%;
    grid-row-gap: 2rem;
    grid-template-areas: "center" "left";
    a {
      font-size: var(--font-size-base);
    }
    p {
      font-size: var(--font-size-xs);
    }
  }
`;
